import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as AccordionArrow } from "../../assets/images/AccrodionArrow.svg";
import { ReactComponent as DraggableIcon } from "../../assets/images/DraggableIcon.svg";
import { ReactComponent as StopIcon } from "../../assets/images/StopIcon.svg";
import { ReactComponent as CrossIconGroupBy } from "../../assets/images/CrossIconGroupBy.svg";
import { ReactComponent as SendIcon } from "../../assets/images/sendIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/editIconAdvancedFilter.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/crossIconAdvancedFilter.svg";
import { ReactComponent as DisclaimerIcon } from "../../assets/images/disclaimerIcon.svg";
import { capitalizeString, safeJsonParse } from "../../utils/utilityFunctions/stringUtility";
import Button from "../UniversalComponents/DefaultButton";
import CustomAccordion from "./CustomAccordion";

import BasicSelect from "../Task/BasicSelect";
import SelectComponent from "./SelectComponent";
import InputComponent from "./InputComponent";
import { FlatTree } from "framer-motion";
import { usePostMetaSaveMutation } from "../../utils/customer/customerListHeader";
import { getCompanyId } from "../../utils/utilityFunctions/localServices";
import { Dialog } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import AdvancedButtonGroup from "./AdvancedButtonGroup";
// import ConfirmationDialog from "./ConfirmationDialogBox";
import ConfirmationDialog from "./ConfirmationDialogMulti";
import {
  buildOptionsFromList,
  buildOptionsFromListCustomer,
  getFlattenedUniqueValues,
} from "../../utils/utilityFunctions/CustomerReactTable/CustomerUtility";

const AdvancedFilterComponent = ({
  groupBy,
  setGroupBy,
  handleClearAllGrouping,
  table,
  view,
  metaData,
  refetchHeader,
  closeAdvancedFilter,
  disableSaveFilter,
  receiveMetaDataPayload,
}) => {
  const conditionOptions = [
    { value: "Is" },
    { value: "Isn't" },
    { value: "Contains" },
    { value: "Doesn't Contain" },
    { value: "StartsWith" },
    { value: "EndsWith" },
    { value: "IsEmpty" },
    { value: "IsNotEmpty" },
  ];
  const dispatch = useDispatch();
  const [currentSelectedColumn, setCurrentSelectedColumn] = useState(null);
  const [currentSelectedColumnValue, setCurrentSelectedColumnValue] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [filterValueToBeSet, setFilterValueToBeSet] = useState({}); // this is filter state which is to be set by clicking on the send icon
  const [activeFilters, setActiveFilters] = useState([]); //this is the filter state, over which we are mapping to display the filters from the saved view
  const [activeIndex, setActiveIndex] = useState(null);
  const [isApplyFilterDialogueOpen, setIsApplyFilterDialogueOpen] = useState(false);
  const [isDeleteDialogueOpen, setIsDeleteDialogueOpen] = useState(false);
  const [viewName, setViewName] = useState("");
  const [savedFilters, setSavedFilters] = useState([]); //this is the state which we are using to store the metadata.filters from header api
  const [savedFiltersNameArray, setSavedFiltersNameArray] = useState([]);
  const [appliedFilterView, setAppliedFilterView] = useState(null); //this state we will use to store which of the saved filters is currently active
  const [storedRemoveView, setStoredRemoveView] = useState(null);
  const visibleColumns = table
    .getVisibleLeafColumns()
    .filter((column) => !["is_deletable", "select", "completionAction"].includes(column.id));

  const dragItemIndex = useRef(null);

  const [selectedAction, setSelectedAction] = useState(null);

  //post filter value to be set, and also the endpoint used here is specific to customer, will
  //pass this function postfiltersave as a prop, from outer

  const [postFilterSave, { isLoading, isSuccess, isError, error }] = usePostMetaSaveMutation();
  const handleCheckboxChange = (item) => {
    setAppliedFilterView((prev) => {
      if (prev !== null && prev == item) {
        table.resetColumnFilters();
        setActiveFilters([]);
      }

      if (prev !== item) {
        table.resetColumnFilters(); //reset filter
        const updatedFilters = metaData?.advanced_filters[item];
        setActiveFilters(updatedFilters);
      }

      return prev === item ? null : item;
    });
  };

  const removeViewDialog = (item) => {
    setIsDeleteDialogueOpen(true);
    setStoredRemoveView(item);
  };

  const resetFilterPopulatedData = () => {
    setCurrentSelectedColumn(null);
    setCurrentSelectedColumnValue(null);
    setSelectedCondition(null);
    setFilterValueToBeSet({});
  };
  const removeView = async (item) => {
    const updatedFilters = Object.fromEntries(
      Object.entries(metaData?.advanced_filters || {}).filter(([key]) => key !== item)
    );
    console.log(updatedFilters, "updatedFilters");

    try {
      const payload = {
        filter_management: {
          advanced_filters: updatedFilters.length > 0 ? updatedFilters : null,
        },
      };

      const response = await receiveMetaDataPayload(payload);
      if (response?.success) {
        setViewName("");
        closeDeleteDialogue();
        resetFilterPopulatedData();
        setIsApplyFilterDialogueOpen(false);
        setActiveFilters([]);
        setAppliedFilterView(null);
        setSelectedAction(null);
        table.resetColumnFilters();
        refetchHeader();

        dispatch(
          pushAlert({
            visible: true,
            message: "SavedFilter Removed Successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "View Not Updated",
            type: "danger",
          })
        );
      }
    } catch (error) {}
  };

  const applyFilter = async (e) => {
    // console.log("conditionforapplyfilter", condition);

    try {
      let metaDataFilters = { ...metaData?.advanced_filters };

      if (appliedFilterView && !viewName) {
        metaDataFilters = {
          ...metaData?.advanced_filters,
          [appliedFilterView]: activeFilters,
        };
      } else {
        metaDataFilters = {
          ...metaData?.advanced_filters,
          [viewName]: activeFilters,
        };
      }

      const payload = {
        filter_management: {
          advanced_filters: metaDataFilters,
        },
      };
      const response = await receiveMetaDataPayload(payload);

      if (response?.success) {
        setViewName("");
        setIsApplyFilterDialogueOpen(false);
        setActiveFilters([]);
        resetFilterPopulatedData();
        setAppliedFilterView(null);
        setSelectedAction(null);
        table.resetColumnFilters();
        refetchHeader();

        dispatch(
          pushAlert({
            visible: true,
            message: "View Updated Successfully",
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "View Not Updated",
            type: "danger",
          })
        );
      }
    } catch (err) {
      console.error("Error saving filter:", err);
    }
  };

  const applyFilterConfirmation = async (e, condition) => {
    if (appliedFilterView && condition == "Save and Close") {
      applyFilter(e, condition);
    } else {
      setIsApplyFilterDialogueOpen(true);
    }
  };

  const options = [
    { label: "Save and Close", value: "Save and Close", onClick: applyFilterConfirmation },
    { label: "Save and New", value: "Save and New", onClick: applyFilterConfirmation },
  ];

  const closeApplyFilterDialogue = () => {
    setIsApplyFilterDialogueOpen(false);
  };
  const closeDeleteDialogue = () => {
    setIsDeleteDialogueOpen(false);
    setStoredRemoveView(null);
  };

  useEffect(() => {
    setFilterValueToBeSet((prev) => ({
      ...prev,
      condition: selectedCondition,
    }));
  }, [selectedCondition]);

  useEffect(() => {
    console.log("advanced filter metadata", metaData);

    if (metaData?.advanced_filters) {
      console.log("advanced filter metadata", metaData);
      setSavedFilters(metaData?.advanced_filters);
      setSavedFiltersNameArray(Object.keys(metaData?.advanced_filters));
    }
  }, [metaData]);

  useEffect(() => {
    console.log("appliedFilterView", appliedFilterView);

    const toBeApplied = Object.keys(metaData?.advanced_filters || {})
      .filter((key) => appliedFilterView?.includes(key))
      .reduce((obj, key) => {
        obj[key] = metaData?.advanced_filters[key];
        return obj;
      }, {});

    visibleColumns?.forEach((column) => {
      const matchingEntry = Object.values(toBeApplied)
        .flat()
        .find((item) => item?.column?.id === column.id);

      if (matchingEntry) {
        console.log("matchingEntry", matchingEntry);
        column.setFilterValue({ keyword: matchingEntry?.keyword, condition: matchingEntry?.condition });
      }
    });

    // console.log("tobeApplied",toBeApplied);
    // console.log("visiblecolumns",visibleColumns);
  }, [appliedFilterView]);

  const handleSendIconClick = (e) => {
    // If editing existing filter
    if (activeIndex !== null && activeIndex !== undefined) {
      const tableFilters = table.getState().columnFilters;
      const updatedTableFilters = tableFilters.filter((_, index) => index !== activeIndex);

      table.setColumnFilters(updatedTableFilters);
      // when setting filter from forntend, this currentslectedcolumn was working fine, but when we fetch from api,
      //and than set it to currentselectedcolumn, it is not working, therfeore mapping from table columns, rather from the direct state
      console.log("currentSelectedColumntestfor", currentSelectedColumn);
      console.log("visibleColumnstestfor", visibleColumns);

      const matchingColumn = visibleColumns?.filter((col) => col.id == currentSelectedColumn?.id)[0];

      matchingColumn?.setFilterValue({
        keyword: filterValueToBeSet?.keyword,
        condition: filterValueToBeSet?.condition,
      });
      // currentSelectedColumn?.setFilterValue({
      //   keyword: filterValueToBeSet?.keyword,
      //   condition: filterValueToBeSet?.condition,
      // });

      setActiveFilters((prev) => {
        const filtered = prev.filter((_, index) => index !== activeIndex);
        return [
          ...filtered,
          {
            column: currentSelectedColumn,
            condition: filterValueToBeSet?.condition,
            keyword: filterValueToBeSet?.keyword,
          },
        ];
      });

      setActiveIndex(null);
    } else {
      console.log("currentSelectedColumntestfor", currentSelectedColumn);
      console.log("visibleColumnstestfor", visibleColumns);

      const matchingColumn = visibleColumns?.filter((col) => col?.id === currentSelectedColumn?.id)[0];

      matchingColumn?.setFilterValue({
        keyword: filterValueToBeSet?.keyword,
        condition: filterValueToBeSet?.condition,
      });

      // currentSelectedColumn?.setFilterValue({
      //   keyword: filterValueToBeSet?.keyword,
      //   condition: filterValueToBeSet?.condition,
      // });
      // If adding a new filter
      setActiveFilters((prev) => [
        ...prev,
        {
          column: currentSelectedColumn,
          condition: filterValueToBeSet?.condition,
          keyword: filterValueToBeSet?.keyword,
        },
      ]);
    }

    // Clear form states
    setCurrentSelectedColumn(null);
    setCurrentSelectedColumnValue(null);
    setSelectedCondition(null);
    setFilterValueToBeSet({});
  };

  const handleClearAllFilters = () => {
    table.setColumnFilters([]);
    setActiveFilters([]);
  };

  //clearindividualfilter from mapped activefilterstate
  const handleClearIndividualFilter = (filter) => {
    const updatedFilters = activeFilters.filter((item) => item.column.id !== filter.column.id);

    setActiveFilters(updatedFilters);

    const tableFilters = table.getState().columnFilters;
    const updatedTableFilters = tableFilters.filter((item) => item.id !== filter.column.id);
    table.setColumnFilters(updatedTableFilters);
  };

  //edit filter from mapped
  const handleEditFilter = (filter, index) => {
    setActiveIndex(index);

    setCurrentSelectedColumn(filter.column);

    setCurrentSelectedColumnValue(filter.column.id);

    setSelectedCondition(filter.condition);

    setFilterValueToBeSet({ column: filter.column, keyword: filter.keyword, condition: filter.condition });
  };

  const handleDrop = (dropIndex) => {
    const draggedIndex = dragItemIndex.current;

    if (draggedIndex === dropIndex) return;

    const updatedGroup = [...groupBy];
    const [movedItem] = updatedGroup.splice(draggedIndex, 1);
    updatedGroup.splice(dropIndex, 0, movedItem);

    setGroupBy(updatedGroup);
  };

  const handleRemove = (itemToRemove) => {
    const updated = groupBy.filter((item) => item !== itemToRemove);
    setGroupBy(updated);
  };

  function Filter({ column, condition }) {
    console.log("columncondition", column, condition);

    //to have dropdown in case of date fields
    if (column?.columnDef?.meta?.type === "date") {
      const options = getFlattenedUniqueValues(column);

      console.log("options for date", options);

      return (
        <SelectComponent
          options={buildOptionsFromListCustomer(options)}
          multiSelect
          showSearch
          noChildren
          onChange={(e) => setFilterValueToBeSet({ column: column, keyword: e.target.value, condition: "Is" })}
          value={filterValueToBeSet?.keyword ? filterValueToBeSet?.keyword : ""}
          size="small"
        ></SelectComponent>
      );
    }

    return (
      <div>
        <input
          type="text"
          name="filtervalue"
          placeholder="Type Something"
          value={filterValueToBeSet?.keyword ? filterValueToBeSet?.keyword : ""}
          //onChange={(e) => column.setFilterValue({keyword:e.target.value,condition:selectedCondition})}
          onChange={(e) =>
            setFilterValueToBeSet({ column: column, keyword: e.target.value, condition: selectedCondition })
          }
          onKeyDown={(e) => e.key === "Enter" && handleSendIconClick(e)}
          className="rounded border border-DFE2E5 bg-white text-[#292E33]  focus:outline-hidden focus:ring-0 focus:border-1D5D9B active:border active:border-DFE2E5 text-xs w-full h-7  whitespace-nowrap overflow-hidden text-ellipsis flex items-center py-[0.5rem] px-[0.714rem] text-[0.9rem]"
          autoFocus
          disabled={selectedCondition === "IsEmpty" || selectedCondition === "IsNotEmpty"}
        />
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col gap-2">
          <span className="flex justify-end">
            <CrossIcon className="w-3 h-3 cursor-pointer" onClick={() => closeAdvancedFilter(false)} />
          </span>
          {!disableSaveFilter && (
            <div className="rounded-[5px] border  border-[#E3E8EC]  py-2 flex flex-col">
              <div className="flex justify-between items-center px-[10px]">
                <p className="text-[#1D4469] font-poppins text-[14px] font-medium ">Saved Filters</p>
                <AccordionArrow />
              </div>
              {savedFiltersNameArray?.length > 0 &&
                savedFiltersNameArray?.map((item, index) => {
                  return (
                    <div className="flex justify-between items-center px-[10px] pt-2 text-[11px]">
                      <div className="flex items-center gap-1 text">
                        <input
                          type="checkbox"
                          id={item}
                          checked={appliedFilterView === item}
                          onChange={() => handleCheckboxChange(item)}
                          className="w-4 h-4 text-blue-600 accent-blue-500 rounded-sm border-[#D9D9D9]"
                        />
                        <div className="text-[#2A2E34] font-poppins text-[11px] font-400 ml-2">{item}</div>
                      </div>

                      <div className="flex items-center gap-1">
                        {/* <button><DisclaimerIcon /></button> */}
                        <button
                          onClick={() => {
                            removeViewDialog(item);
                          }}
                        >
                          <CrossIcon className="w-3 h-3" />
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
          <div className="rounded-[5px] border  border-[#E3E8EC]  py-2 flex flex-col">
            <div className="flex justify-between items-center px-[10px]">
              <p className="text-[#1D4469] font-poppins text-[14px] font-medium ">Group By</p>
              <AccordionArrow />
            </div>
            <div className="px-[10px]">
              {groupBy?.map((item, index) => {
                return (
                  <div
                    key={index}
                    draggable
                    onDragStart={() => (dragItemIndex.current = index)}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={() => handleDrop(index)}
                    className="flex items-center justify-between py-[3px] "
                  >
                    <div className="flex items-center gap-1 cursor-grab active:cursor-grabbing">
                      <DraggableIcon className="fill-[#CCD4DC]" />
                      <p className="text-[#2A2E34] font-poppins text-[11px] font-400 capitalize">
                        {table
                          .getAllColumns()
                          .filter((col) => col.columnDef.accessorKey === item)
                          .map((col) => col.columnDef.header)[0] || item}
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        handleRemove(item);
                      }}
                    >
                      <CrossIconGroupBy />
                    </button>
                  </div>
                );
              })}
            </div>
            {groupBy.length > 0 && (
              <button
                className="flex items-center justify-end text-[#EF4444] font-poppins text-[10px] font-normal  py-[5px]  border-t border-[#D2DAE1]"
                onClick={handleClearAllGrouping}
              >
                <div className="flex items-center gap-1 px-[10px]">
                  <StopIcon />
                  <p>Stop Group By</p>
                </div>
              </button>
            )}
          </div>
          <div className="rounded-[5px] border  border-[#E3E8EC]  pt-2 flex flex-col">
            <div>
              <div className="flex justify-between items-center px-[10px]">
                <p className="text-[#1D4469] font-poppins text-[14px] font-medium ">Advanced Filter</p>
                <AccordionArrow />
              </div>

              {/* column select */}
              <div className="px-[10px] py-2">
                <BasicSelect
                  options={visibleColumns
                    ?.filter((col) => !activeFilters?.some((filter) => filter.column.id === col.id))
                    .map((col) => ({
                      value: col?.id,
                      label: capitalizeString(col?.columnDef?.header),
                      col: col,
                    }))}
                  label={"Column"}
                  name="Column"
                  onChange={(e) => {
                    setCurrentSelectedColumn(e.target.col);
                    setCurrentSelectedColumnValue(e.target.value);
                  }}
                  value={currentSelectedColumnValue}
                  selectedOptions={visibleColumns
                    ?.filter((item) => item.id === currentSelectedColumnValue)
                    .map((item) => ({ value: item?.id, label: capitalizeString(item?.columnDef?.header) }))}
                  showSearch={true}
                />
              </div>

              {/* condition select */}
              {/* by default conditon will be is, when type is date, so only conditionally render this */}
              {currentSelectedColumn && currentSelectedColumn?.columnDef?.meta?.type !== "date" && (
                <div className="px-[10px] py-2 w-full">
                  <BasicSelect
                    options={conditionOptions?.map((col) => ({
                      value: col?.value,
                      label: col?.value,
                    }))}
                    size="high"
                    label={"Condition"}
                    name="Condition"
                    onChange={(e) => {
                      //will look into this later, did this for clearing condition text when isEmpty or isNotEmpty is selected
                      // if(e.target.value==="IsEmpty" || e.target.value=="IsNotEmpty")
                      //   {
                      //     setFilterValueToBeSet((prev)=>({...prev,keyword:""}))
                      // }
                      setSelectedCondition(e.target.value);
                    }}
                    selectedOptions={conditionOptions
                      ?.filter((item) => item.value === selectedCondition)
                      .map((item) => ({ label: item?.value, value: item?.value }))}
                  />
                </div>
              )}
              <div className="px-[10px] py-2 flex gap-7 items-center">
                {currentSelectedColumn && (
                  <>
                    <Filter column={currentSelectedColumn} condition={selectedCondition} />

                    <button
                      className="w-[28px] h-[26px] flex items-center justify-center rounded-[3px] border border-[#1D44691A] bg-[#EBF2F6]"
                      onClick={(e) => {
                        handleSendIconClick(e);
                        // currentSelectedColumn?.setFilterValue({
                        //   keyword: filterValueToBeSet?.keyword,
                        //   condition: filterValueToBeSet?.condition,
                        // });

                        // setActiveFilters(prev => [
                        //   ...prev,
                        //   {
                        //     column: currentSelectedColumn,
                        //     condition: filterValueToBeSet?.condition,
                        //     keyword: filterValueToBeSet?.keyword,
                        //   },
                        // ]);
                      }}
                    >
                      <SendIcon />
                    </button>
                  </>
                )}
              </div>
            </div>
            {activeFilters?.length > 0 && (
              <div>
                <div className="px-[10px] flex justify-between">
                  <div className="text-[#2A2E34] font-poppins text-[11px] font-medium ">Conditions</div>
                  <button
                    className="text-[#EF4444] text-right font-poppins text-[10px] font-400 leading-[15px]"
                    onClick={(e) => {
                      handleClearAllFilters();
                      // table.setColumnFilters([]);
                    }}
                  >
                    Clear Filters
                  </button>
                </div>
                <div className="mt-1 mb-1 px-[10px] flex flex-col gap-[5px] max-h-60 overflow-auto thinscrollbar ">
                  <>
                    {activeFilters?.map((filter, index) => (
                      <div
                        className={`rounded-[5px] border-[] bg-[rgba(206,206,206,0.3)] pl-[10px] pt-[5px] pr-[5px] ${
                          index === activeIndex ? { border: "1px solid #D2DAE180" } : ""
                        }`}
                      >
                        <div className="flex flex-col ">
                          <div className="flex justify-between items-center">
                            <div className="text-[#383838] font-poppins text-[10px] font-medium leading-[18px]">
                              {capitalizeString(filter?.column?.columnDef.header)}
                            </div>
                            <div className="flex items-center gap-2">
                              <button
                                onClick={(e) => {
                                  handleEditFilter(filter, index);
                                }}
                              >
                                <EditIcon />
                              </button>
                              <button
                                onClick={(e) => {
                                  handleClearIndividualFilter(filter);
                                }}
                              >
                                {" "}
                                <CrossIcon className="w-3 h-3" />
                              </button>
                            </div>
                          </div>
                          <div className="text-[#888] font-poppins text-[10px] font-normal leading-[18px]">
                            {filter?.condition}
                          </div>
                          <div className="text-[#888] font-poppins text-[10px] font-normal leading-[18px]">
                            {filter?.keyword}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                </div>
              </div>
            )}
          </div>
        </div>
        {!disableSaveFilter && (
          <div className="flex items-center justify-end gap-2 py-[10px]">
            {/* <Button variant="secondary" size="small">
            Cancel
          </Button>

          <Button variant="primary" size="small" onClick={applyFilterConfirmation}>
            Save Filter
          </Button> */}

            <AdvancedButtonGroup
              primaryText={"Save Filter"}
              primaryClick={applyFilterConfirmation}
              secondaryClick={closeAdvancedFilter}
              secondaryText={"Cancel"}
              primaryType={"button"}
              secondaryType={"button"}
              options={options}
              selectedAction={selectedAction}
              setSelectedAction={setSelectedAction}
              appliedFilterView={appliedFilterView}
              className={"py-[5px]"}
              disableConditionForSave={activeFilters}
            />
          </div>
        )}
      </div>
      {isApplyFilterDialogueOpen && (
        <Dialog open={isApplyFilterDialogueOpen} onClose={closeApplyFilterDialogue}>
          <div className="w-96 flex flex-col">
            <div className="flex items-center justify-between px-[15px] py-[10px] rounded-t-[10px] border-b border-[#BECBD3] ">
              <p className="text-[#434852] font-[Poppins] text-base font-medium capitalize">Save Filter</p>
              <button onClick={closeApplyFilterDialogue}>
                <CrossIcon />{" "}
              </button>
            </div>
            <div className="p-[15px] flex flex-col gap-1">
              <div className="text-[#434852] font-poppins text-[12px] font-normal leading-normal">Filter Name</div>
              <InputComponent
                type="text"
                id="viewName"
                name="viewName"
                placeholder="Enter Filter Name"
                value={viewName}
                onKeyDown={(e) => e.key === "Enter" && applyFilter()}
                onChange={(e) => {
                  setViewName(e.target.value);
                }}
              />
            </div>
            <div className="pb-[15px] pr-[15px] flex justify-end gap-[10px]">
              <Button variant="secondary" size="small" onClick={closeApplyFilterDialogue}>
                Cancel
              </Button>
              <Button variant="primary" size="small" onClick={applyFilter}>
                Save
              </Button>
            </div>
          </div>
        </Dialog>
      )}
      {isDeleteDialogueOpen && (
        <ConfirmationDialog
          open={isDeleteDialogueOpen}
          onConfirm={(e) => removeView(storedRemoveView)}
          onClose={() => closeDeleteDialogue()}
          title="Remove Filter"
          message="Are you sure you want to remove this filter?"
          confirmVariant="primary"
          iconVariant="primary"
          confirmText="Yes"
          cancelText="No"
        />
      )}
    </>
  );
};

export default AdvancedFilterComponent;
